<template>
	<section class="itv-search">
		<form>
			<input-text
				:placeholder="SEARCH.placeholder"
				:name="SEARCH.name"
				:type="SEARCH.type"
				:id="SEARCH.id"
				:param-name="paramName"
				@change-value="fieldHandler"
				@keydown.enter.stop="emitValue"
			>
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M7.40741 3.33333C5.15736 3.33333 3.33333 5.15736 3.33333 7.40741C3.33333 9.65746 5.15736 11.4815 7.40741 11.4815C8.50311 11.4815 9.49779 11.0489 10.23 10.3453C10.2466 10.3241 10.2646 10.3037 10.2842 10.2842C10.3037 10.2646 10.3241 10.2466 10.3453 10.23C11.0489 9.49779 11.4815 8.50311 11.4815 7.40741C11.4815 5.15736 9.65746 3.33333 7.40741 3.33333ZM11.6734 10.7306C12.3887 9.81376 12.8148 8.66035 12.8148 7.40741C12.8148 4.42098 10.3938 2 7.40741 2C4.42098 2 2 4.42098 2 7.40741C2 10.3938 4.42098 12.8148 7.40741 12.8148C8.66035 12.8148 9.81376 12.3887 10.7306 11.6734L12.8619 13.8047C13.1223 14.0651 13.5444 14.0651 13.8047 13.8047C14.0651 13.5444 14.0651 13.1223 13.8047 12.8619L11.6734 10.7306Z"
						fill="#252628"
					/>
				</svg>
			</input-text>
			<div v-if="!isMobile" class="itv-search__btn">
				<primary-button :content="button" @click-event="emitValue" />
			</div>
		</form>
	</section>
</template>

<script>
import InputText from '../ui/InputText'
import PrimaryButton from '../ui/PrimaryButton'

export default {
	name: 'Search',
	components: {
		InputText,
		PrimaryButton,
	},
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		code: {
			type: String,
			default: '',
		},
		paramName: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			wait: false,
			SEARCH: {
				id: 'SEARCH',
				type: 'text',
				placeholder: '',
				value: '',
				name: '',
			},

			button: {
				btnColorType: 'green',
				text: 'Найти',
			},
		}
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	methods: {
		fieldHandler(val) {
			this.SEARCH.value = val

			if (!this.SEARCH.value || this.SEARCH.value.length === 0) this.emitValue()

			if (!this.isMobile) return

			if (this.SEARCH.value && this.SEARCH.value.length > 2) {
				const DELAY = 500
				if (!this.wait) {
					this.wait = true
					setTimeout(() => {
						this.wait = false
						this.emitValue()
					}, DELAY)
				}

				return
			}
		},

		emitValue() {
			let value = this.SEARCH.value
			if (value) value = value.toLowerCase()
			this.$emit('change-event', value)
		},
	},
	created() {
		this.SEARCH.id = this.code
		this.SEARCH.name = this.code
		this.SEARCH.placeholder = this.placeholder
	},
}
</script>
